import script from "./AfterInvestAssetRisk.vue?vue&type=script&setup=true&lang=js"
export * from "./AfterInvestAssetRisk.vue?vue&type=script&setup=true&lang=js"

import "./AfterInvestAssetRisk.vue?vue&type=style&index=0&id=7972b0da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7972b0da"]])

export default __exports__